exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-188b503d]::-webkit-input-placeholder {\n  font-style: italic;\n  color: #767676;\n}\ninput[data-v-188b503d]::-moz-placeholder {\n  font-style: italic;\n  color: #767676;\n}\ninput[data-v-188b503d]:-ms-input-placeholder {\n  font-style: italic;\n  color: #767676;\n}\ninput[data-v-188b503d]::-ms-input-placeholder {\n  font-style: italic;\n  color: #767676;\n}\ninput[data-v-188b503d]::placeholder {\n  font-style: italic;\n  color: #767676;\n}\ninput[data-v-188b503d]::-webkit-calendar-picker-indicator:hover {\n  background-color: transparent;\n}", ""]);

// exports
